"use strict";
exports.__esModule = true;
exports.ActionKey = exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType[ActionType["ALERT"] = 0] = "ALERT";
    ActionType[ActionType["INTERNAL_SMS"] = 1] = "INTERNAL_SMS";
    ActionType[ActionType["INTERNAL_EMAIL"] = 2] = "INTERNAL_EMAIL";
    ActionType[ActionType["WEBHOOK"] = 3] = "WEBHOOK";
    ActionType[ActionType["ENTITY_UPDATE"] = 4] = "ENTITY_UPDATE";
    ActionType[ActionType["RELEASE"] = 5] = "RELEASE";
    ActionType[ActionType["MARK_NOT_READY"] = 6] = "MARK_NOT_READY";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ActionKey;
(function (ActionKey) {
    ActionKey["UPDATE"] = "updateEntity";
    ActionKey["GENERIC_ACTION"] = "genericAction";
})(ActionKey = exports.ActionKey || (exports.ActionKey = {}));
//# sourceMappingURL=action.js.map